import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { messages, DEFAULT_LANG, LANG_STORAGE_KEY, HTML_LANG, type Lang } from './messages'

/**
 * Instância única do i18next (runtime de i18n do app). As traduções vêm de
 * `messages` (núcleo + dicionários por tela coletados por glob em messages.ts).
 * Chaves são planas e com ponto (`nav.dashboard`, `dashboard.kpi.requested`) →
 * `keySeparator: false` para o ponto NÃO virar aninhamento. Interpolação i18next
 * usa `{{nome}}`. O idioma inicial vem do localStorage (default PT).
 */
function detectInitialLang(): Lang {
  try {
    const v = localStorage.getItem(LANG_STORAGE_KEY)
    if (v === 'pt' || v === 'en' || v === 'es') return v
  } catch {
    /* ignore */
  }
  return DEFAULT_LANG
}

const initialLang = detectInitialLang()

void i18n.use(initReactI18next).init({
  resources: {
    pt: { translation: messages.pt },
    en: { translation: messages.en },
    es: { translation: messages.es },
  },
  lng: initialLang,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: ['pt', 'en', 'es'],
  keySeparator: false,
  nsSeparator: false,
  returnNull: false,
  interpolation: { escapeValue: false },
})

// Reflete o idioma no <html lang> (o index.html já faz pré-paint; aqui garante dev).
try {
  document.documentElement.setAttribute('lang', HTML_LANG[initialLang])
} catch {
  /* ignore */
}

export default i18n
